import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';

const numberPipe = new DecimalPipe('en-US');
@Injectable({ providedIn: 'root' })
export class ErrorMessageHelper {
    constructor(private _i18n: I18n) {}

    public PERMISSION_ERROR = this._i18n({
        value:
            'You do not have the correct permissions to view this content. Please inform your company admin.',
        meaning: 'generic permissions error'
    });

    public GENERIC_ERROR = this._i18n({
        value: 'Something went wrong and our engineering team has been informed.',
        meaning: 'generic error message'
    });

    // TODO: Move these to their validators after legacy validators are removed.
    public disallowZero = this._i18n({ value: 'Please enter a number other than 0' });
    public required = this._i18n({ value: 'This field is required' });
    public requiredTrue = this._i18n({ value: 'Please check the box to proceed' });
    public pattern = this._i18n({ value: 'The value entered is invalid' });
    public email = this._i18n({ value: 'Please enter a valid email' });
    public currency = this._i18n({ value: 'Please enter a valid currency value' });
    public match = this._i18n({ value: 'This field does not match' });
    public different = this._i18n({ value: 'This field should not match' });
    public date = this._i18n({ value: 'Please enter a valid date' });
    public dataSourceError = this._i18n({
        value: 'An error has occurred. Try reloading the page.'
    });
    public pastDate = this._i18n({ value: 'Please enter a date in the past' });
    public json = this._i18n({ value: 'Please input valid JSON' });
    public genericServerError = this._i18n({
        value: 'Something went wrong and our engineering team has been informed.'
    });
    public number = this._i18n({ value: 'Please enter a number' });
    public password = this._i18n({ value: 'The password you entered is invalid' });
    public passwordRequirementsNotMet = this._i18n({ value: 'Does not meet requirements' });
    public permission = this._i18n({
        value:
            'You do not have the correct permissions to view this content. Please inform your company admin.'
    });
    public positiveNumber = this._i18n({ value: 'Please enter a number greater than 0' });
    public zeroOrGreaterNumber = this._i18n({ value: 'Please enter a value of 0 or greater' });
    public wholeNumber = this._i18n({ value: 'Please enter a whole number' });
    public fullName = this._i18n({ value: 'Please enter a first and last name' });
    public maxNumber = (max: string | number) => this.max(max);
    public minNumber = (min: string | number) => this.min(min);
    public numberRange = (min: number, max: number) =>
        this._i18n('Please enter a number between {{minNumber}} and {{maxNumber}}', {
            minNumber: numberPipe.transform(min),
            maxNumber: numberPipe.transform(max)
        });
    public exactLength = (length: number) =>
        this._i18n('Please enter {{characterLength}} characters', { characterLength: length });
    public maxLength = (max: number) =>
        this._i18n('Please enter {{maxNumber}} or fewer characters', { maxNumber: max });
    public minLength = (min: number) =>
        this._i18n('Please enter {{minNumber}} or more characters', { minNumber: min });
    public max = (max: string | number) =>
        this._i18n('Please enter a number less than or equal to {{maxNumber}}', { maxNumber: max });
    public min = (min: string | number) =>
        this._i18n('Please enter a number greater than or equal to {{minNumber}}', {
            minNumber: min
        });
}
